import { useGetUsersMeQuery } from '../api/user/queries/useGetUsersMe.query';
import { useUpdateBrowserStorage } from '../browserStorage/useUpdateBrowserStorage';
import { useCheckAppVersion } from '../check/useCheckAppVersion';
import { useCheckCameraPermission } from '../check/useCheckCameraPermission';
import { useCheckGlobalTooltip } from '../check/useCheckGlobalTooltip';
import { useCheckUserEnvironment } from '../check/useCheckUserEnvironment';
import { useStorePageToRedirection } from '../page/useStorePageToRedirection';
import { useScalable } from '../screen/useScalable';
import { useRestoreScrollY } from '../store/scrollY/useRestoreScrollY';
import { useStoreScrollY } from '../store/scrollY/useStoreScrollY';
import { useAmplitude } from '../third-party/amplitude/useAmplitude';
import { useCatchQueryString } from '../third-party/amplitude/useCatchQueryString';
import { useClarity } from '../third-party/amplitude/useClarity';
import { useChannelTalk } from '../third-party/channelTalk/useChannelTalk';
import { useGA } from '../third-party/ga/useGA';
import { useGrowthBook } from '../third-party/growthBook/useGrowthBook';
import { useRNSetUserId } from '../third-party/react-native/useRNSetUserId';
import { useUpdateFlarelaneTag } from '../user/useUpdateFlarelaneTag';
import { useBrowserBackReload } from './useBrowserBackReload';

export const useAppSetup = () => {
  useCheckCameraPermission();
  useGetUsersMeQuery();
  useAmplitude();
  useRNSetUserId();
  useGA();
  useClarity();
  useStoreScrollY();
  useRestoreScrollY();
  useCheckUserEnvironment();
  useCheckAppVersion();
  useCatchQueryString();
  useScalable();
  useChannelTalk();
  useCheckGlobalTooltip();
  useStorePageToRedirection();
  useUpdateBrowserStorage();
  useUpdateFlarelaneTag();
  useGrowthBook();
  useBrowserBackReload();
};
